module.exports = __webpack_public_path__ + "img/elorejelzes_novenyvedelem_pop_up.31a30fde.png";